import { render, staticRenderFns } from "./safe-drawer-transaction-detail.vue?vue&type=template&id=bcf29098&scoped=true"
import script from "./safe-drawer-transaction-detail.vue?vue&type=script&lang=js"
export * from "./safe-drawer-transaction-detail.vue?vue&type=script&lang=js"
import style0 from "./safe-drawer-transaction-detail.vue?vue&type=style&index=0&id=bcf29098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf29098",
  null
  
)

export default component.exports